"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENT_UPDATE_SELF = exports.RequestType = void 0;
/**
 * The socket update request type
 */
var RequestType;
(function (RequestType) {
    RequestType[RequestType["Equipment"] = 0] = "Equipment";
    RequestType[RequestType["Defects"] = 1] = "Defects";
})(RequestType = exports.RequestType || (exports.RequestType = {}));
/**
 * Event emitted to the requested to the user when there's a data change
 */
exports.EVENT_UPDATE_SELF = "update-self";
//# sourceMappingURL=project-event.js.map